import { render, staticRenderFns } from "./BitrixExportPurchaseItem.vue?vue&type=template&id=2a492b54&scoped=true"
import script from "./BitrixExportPurchaseItem.vue?vue&type=script&lang=js"
export * from "./BitrixExportPurchaseItem.vue?vue&type=script&lang=js"
import style0 from "./BitrixExportPurchaseItem.vue?vue&type=style&index=0&id=2a492b54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a492b54",
  null
  
)

export default component.exports